import React from 'react';


const DivEnd = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={`d-flex justify-content-end align-items-center ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default DivEnd;
